import 'reflect-metadata';
/**
 * Get all decorators
 * @param target
 * @param properties
 */
export function getAllDecorators(target, properties) {
    return properties.map((propertyName) => {
        const decorators = Reflect.getMetadataKeys(target, propertyName);
        // if (decorators.length > 0) {
        return {
            propertyName,
            decorators,
        };
        // }
    });
}
/**
 * List all methods in object
 * @param obj
 * @param inherited
 */
// TODO factorize function
export function getMethods(obj, deep = 0) {
    const properties = new Set();
    let index = 0;
    let currentObj = obj; // typeof obj === 'object' ? Object.getPrototypeOf(obj) : obj;
    do {
        // console.info({
        //     currentObj,
        //     props: Object.getOwnPropertyNames(currentObj)
        // })
        Object.getOwnPropertyNames(currentObj).map((item) => properties.add(item));
        index++;
    } while (index <= deep && (currentObj = Object.getPrototypeOf(currentObj)));
    return [...properties.keys()].filter((item) => {
        try {
            return typeof obj[item] === 'function';
        }
        catch (err) {
            // console.error(`Cannot access ${item}`, err);
            return false;
        }
    });
}
